"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowLeftBigIcon = void 0;
const react_1 = __importDefault(require("react"));
const Theme_1 = require("@/Theme");
const ArrowLeftBigIcon = (_a) => {
    var { stroke } = _a, props = __rest(_a, ["stroke"]);
    return (react_1.default.createElement("svg", Object.assign({ width: "26", height: "26" }, props, { viewBox: "0 0 26 26", fill: "none", xmlns: "http://www.w3.org/2000/svg" }),
        react_1.default.createElement("path", { d: "M24.785 13.0007L1.70249 13.0003M12.9999 24.7858L1.2148 13.0007L12.9999 1.21558", stroke: stroke || Theme_1.theme.palette.BW_0, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.ArrowLeftBigIcon = ArrowLeftBigIcon;
